export default {
  rankOrder: {
    ariaAddOption: 'Engeza {label} kuluhlu olwangeziwe',
    ariaMoveUp: 'Hambisa {label} phezulu',
    ariaMoveDown: 'Hambisa {label} phansi',
    ariaRemoveOption: 'Susa {label} kuluhlu olwangeziwe',
  },
  coe: {
    ariaDisclaimer: 'Isaziso',
    ariaQuestion: 'Umbuzo',
    ariaConversationHistory: 'Umlando wengxoxo',
    ariaYourResponse: 'Impendulo yakho {number}',
    ariaFollowUpQuestion: 'Umbuzo olandelayo {number}',
    ariaResponseInput: 'Insimu yempendulo',
    ariaRespondingTo: 'Uphendula',
    ariaSendResponse: 'Thumela impendulo',
    ariaThinking: 'Ukucabanga'
  },
  deviceView: {
    toolbar: 'Idivayisi yokubuka kuqala',
    mobile: 'Iselula',
    tablet: 'Ithebhulethi',
    desktop: 'Ideskithophu'
  },
  header: {
    customLogoAlt: 'Ilogo',
    defaultLogoAlt: 'Ilogo ye-QuestDIY'
  }
}
